import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { AuthService } from '../../services/auth.service';
import { ValidationService } from '../../services/validation.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormGroup, FormControl, Validators, ReactiveFormsModule, FormBuilder } from '@angular/forms';
declare var $:any;
@Component({
	selector: 'app-change-password',
	templateUrl: './change-password.component.html',
	styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {
	changePasswordForm;
	constructor(private commonService: CommonService, private authService: AuthService, private router: Router,
		private validationService: ValidationService, private formBuilder: FormBuilder) { }

	ngOnInit() {
		this.commonService.setTitle();
		this.commonService.process();
		var service = this.commonService;
		setTimeout(function(){ service.hideProcess(); }, 1000);

		this.changePasswordForm = new FormGroup({
			old_password: new FormControl("", Validators.compose([
				Validators.required,
				Validators.minLength(6)
			])),

			new_password: new FormControl("", Validators.compose([
				Validators.required,
				Validators.minLength(6)
			])),

			c_password: new FormControl("", Validators.compose([
				Validators.required,
				Validators.minLength(6)
			])),
		},this.passwordMatchValidator);
	}
	passwordMatchValidator(g: FormGroup) {
		return g.get('new_password').value === g.get('c_password').value
		   ? null : {'mismatch': true};
	 }
	// Change password functionality
	onSubmit = function (changePasswordData) {
		if (this.changePasswordForm.valid) {
			$("#changePwdBtn").val("Submitting...").attr("disabled",true);
			this.authService.changePassword(changePasswordData).subscribe(data => {
				 if(data.success) {
					this.authService.storeWebToken(data.token);
					$.growl.notice({ title: 'Success', message: data.message });
				 }
				 else{
					$.growl.error({ title: 'Error', message: data.error });
				 }
				 $("#changePwdBtn").val("Submit").attr("disabled",false);
			});
		} else {
			this.validationService.validateAllFormFields(this.changePasswordForm);
		}
	}
}



// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/change-password/change-password.component.ts